<div ng-controller="blackListController as ctrl" class="blacklist-list">
    <div id="managed-component"></div>
</div>